import { render, staticRenderFns } from "./AppToggleSwitch.vue?vue&type=template&id=63abf85a&scoped=true"
import script from "./AppToggleSwitch.vue?vue&type=script&lang=js"
export * from "./AppToggleSwitch.vue?vue&type=script&lang=js"
import style0 from "./AppToggleSwitch.vue?vue&type=style&index=0&id=63abf85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63abf85a",
  null
  
)

export default component.exports